/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-black text-gray-300 p-8 pb-5 mt-3">
      {/* Footer Grid Layout */}
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
        
        {/* Navigation Links */}
        <div>
          <h2 className="text-xl font-bold text-yellow-400 mb-3">Quick Links</h2>
          <ul className="space-y-2">
            <li><Link to="/" className="hover:text-yellow-400 transition" onClick={scrollToTop}>Home</Link></li>
            <li><Link to="/services" className="hover:text-yellow-400 transition" onClick={scrollToTop}>Services</Link></li>
            <li><Link to="/books" className="hover:text-yellow-400 transition" onClick={scrollToTop}>Books</Link></li>
            <li><Link to="/contact" className="hover:text-yellow-400 transition" onClick={scrollToTop}>Contact</Link></li>
            <li><Link to="/about-astrologer" className="hover:text-yellow-400 transition" onClick={scrollToTop}>About-Astrologer</Link></li>
          </ul>
        </div>

        {/* Contact Details */}
        <div>
          <h2 className="text-xl font-bold text-yellow-400 mb-3">Contact Us</h2>
          <p>Email: <a href="mailto:astromahamaya@gmail.com" className="text-yellow-400 hover:underline">astromahamaya@gmail.com</a></p>
          <p>Phone: <a href="tel:+919827504751" className="text-yellow-400 hover:underline">+91 9827504751</a></p>
        </div>

        {/* Social Media Links */}
        <div>
          <h2 className="text-xl font-bold text-yellow-400 mb-3">Follow Us</h2>
          <div className="flex justify-center md:justify-start space-x-6">
            <a href="https://www.instagram.com/astro.mahamaya/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram className="text-2xl hover:text-pink-500 transition" />
            </a>
            <a href="https://www.twitter.com/" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter className="text-2xl hover:text-blue-400 transition" />
            </a>
            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook className="text-2xl hover:text-blue-600 transition" />
            </a>
          </div>
        </div>
      </div>

      {/* Google Map */}
      <div className="mt-8">
        <h2 className="text-xl font-bold text-yellow-400 text-center mb-2">Our Location</h2>
        <p className="mb-4 text-center">69-70, Block-B, Tirupati Solitaire near Hotel Nakshatra, Ujjain, MP (Pin: 456001)</p>
        <div className="w-full h-64 md:h-80">
        <iframe
        title="Google Map"
        width="100%"
        height="100%"
        frameBorder="0"
        style={{ border: 0 }}
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1975.4624301650952!2d75.8026885352943!3d23.19831769807334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396375e26f61b00d%3A0xa075c466ea4331f0!2sAstromahamaya%20jyotish%20karyalay!5e0!3m2!1sen!2sin!4v1742448025642!5m2!1sen!2sin"
        allowFullScreen
      ></iframe>
      
        </div>
      </div>

      {/* Logo */}
      <div className="flex justify-center mt-5">
        <Link to="/" onClick={scrollToTop}>
          <img src="image/Astro_logo_bg_1.webp" alt="Astro-MahaMaya" className="h-12 w-44" fetchPriority="high"/>
        </Link>
      </div>
      {/* Copyright */}
      <div className="text-center mt-6 border-t border-gray-600 pt-4">
        <p>&copy; 2025 Astro-MahaMaya. All rights reserved.</p>
       
      </div>
      <p className="text-xs text-center mt-4"> Developed By Racila Softech Pvt. Ltd.</p>
    </footer>
  );
}

export default Footer;
